import { render } from "./add-pendamping-modal.vue?vue&type=template&id=30f82602&scoped=true"
import script from "./add-pendamping-modal.vue?vue&type=script&lang=js"
export * from "./add-pendamping-modal.vue?vue&type=script&lang=js"

import "./add-pendamping-modal.vue?vue&type=style&index=0&id=30f82602&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f82602"]])

export default __exports__